import { Component, OnInit } from '@angular/core';
import { UserService } from './shared/services/http/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'exam-management';
  hideLoader:boolean = false;
  constructor(private userService:UserService){}

  ngOnInit(): void {
    this.userService.hideLoader.subscribe((res:any)=>{
      this.hideLoader = res;
    });
  }
}
